var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"latest-upload fl"},_vm._l((_vm.latestList.slice(0,10)),function(point,index){return _c('li',{key:index,on:{"click":function($event){return _vm.goInformation(point)}}},[_c('div',{staticClass:"point fl"}),_c('p',[_vm._v(" "+_vm._s(point.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }